import {
  AvatarCircle,
  Heading,
  IconVerticalDivider,
  Subtitle,
  Subtitle10,
  Title4,
} from '@/components/atoms';
import {
  BottomLine,
  Description,
  DescriptionGray,
  DescriptionRed,
  FooterArea,
  Label,
  LabelArea,
  TitleArea,
  Wrapper,
} from './DepositPromoListItem.styled';

interface IProps {
  src: string;
  title?: string;
  subTitle?: string;
  chip?: string | null;
  label?: string | null;
  labelRed?: number | null;
  description?: string | null;
  descriptionRed?: string | null;
  advtText?: string | null;
  desc1?: string | null;
  desc2?: string | null;
}

const DepositPromoListItem = (props: IProps) => {
  const {
    src,
    chip,
    label,
    labelRed,
    description,
    descriptionRed,
    title,
    subTitle,
    advtText,
    desc1,
    desc2,
  } = props;

  return (
    <Wrapper>
      <AvatarCircle size="lg" src={src} alt="deposit" />
      <TitleArea>
        <Subtitle level={6}>{subTitle}</Subtitle>
        <Heading level={2} color="gray-800">
          {title}
        </Heading>
      </TitleArea>
      {(label || labelRed) && (
        <LabelArea>
          {labelRed && (
            <Label>
              <Heading level={2} color="primary-100">
                최고 연
              </Heading>
              <Heading level={1} color="primary-100">
                {labelRed}%
              </Heading>
            </Label>
          )}
          {label && (
            <>
              <IconVerticalDivider width={1} color="gray-400" />
              <Label>
                <Heading level={2}>기본 연</Heading>
                <Heading level={1}>{label}%</Heading>
              </Label>
            </>
          )}
        </LabelArea>
      )}
      {chip && <span>{chip}</span>}
      <FooterArea>
        <DescriptionRed>
          <Subtitle level={6} color="primary-100">
            {descriptionRed}
          </Subtitle>
        </DescriptionRed>
        <Description>
          <Subtitle level={6} color="gray-800">
            {description}
          </Subtitle>
        </Description>
        <Title4 color="primary-100">{advtText}</Title4>
        <Description>
          <Title4 color="gray-800"> {desc1}</Title4>
        </Description>
        <DescriptionGray>
          <Subtitle10 color="gray-500">{desc2}</Subtitle10>
        </DescriptionGray>
        <BottomLine />
      </FooterArea>
    </Wrapper>
  );
};

export default DepositPromoListItem;
